<template>
	<div class="settings">
		<div class="settings-content">
			<MainColumn />
			<CreateTagGroup
				v-if="showCreate"
				@close="showCreate = false"
			/>
			<EditTagGroup
				v-if="showEdit"
				:tag-group="editedTagGroup"
				@close="closeEdit"
			/>
			<TagGroupsList
				v-if="showHome"
				:selected="selectedTagGroup"
				:can-create="canCreateTagGroups"
				:can-edit="canEdiTagGroups"
				@change="onTagGroupSelected"
				@create-tag-group="createTagGroup"
				@edit-tag-group="editTagGroup"
				@duplicate-tag-group="duplicateTagGroup"
			/>
			<TagGroupPreview
				v-if="showHome"
				:tag-group="selectedTagGroup"
				:disabled="!canEdiTagGroups"
				:disabled-message="transUcfirst('one.permissions.view_only_message')"
				@edit-tag-group="editTagGroup"
			/>
		</div>
	</div>
</template>

<script>
import MainColumn from '@videotools/js/one/components/Settings/MainColumn';
import TagGroupsList from '@videotools/js/one/components/TagGroups/TagGroupsList';
import TagGroupPreview from '@videotools/js/one/components/TagGroups/TagGroupPreview';
import { mapActions, mapGetters } from 'vuex';
import CreateTagGroup from '@videotools/js/one/components/TagGroups/CreateTagGroup';
import EditTagGroup from '@videotools/js/one/components/TagGroups/EditTagGroup';

export default {
	name:       'SettingsPageDesktop',
	components: { EditTagGroup, CreateTagGroup, TagGroupPreview, TagGroupsList, MainColumn },
	props:      {
		showTagGroupCreatePage: {
			type: Boolean,
		},
	},
	data() {
		return {
			showCreate:     false,
			showEdit:       false,
			editedTagGroup: null,
		};
	},
	computed: {
		...mapGetters({
			tagGroups:          'tagGroups/tagGroups',
			selectedTagGroup:   'tagGroups/selectedTagGroup',
			canCreateTagGroups: 'permissions/canCreateTagGroups',
			canEdiTagGroups: 	  'permissions/canEditTagGroups',
		}),
		showHome() {
			return !this.showCreate && !this.showEdit;
		},
	},
	created() {
		this.fetchTagGroups().then(() => this.selectDefaultIfNone());
		this.showCreate = this.showTagGroupCreatePage;
	},
	methods: {
		...mapActions({
			fetchTagGroups: 'tagGroups/fetchTagGroups',
			setSelected:    'tagGroups/setSelected',
			duplicate:      'tagGroups/duplicate',
		}),
		onTagGroupSelected(tagGroup) {
			this.setSelected(tagGroup);
		},
		createTagGroup() {
			this.showCreate = true;
		},
		editTagGroup(tg) {
			this.showCreate = false;
			this.showEdit = true;
			this.editedTagGroup = tg;
		},
		duplicateTagGroup(tagGroup) {
			this.duplicate(tagGroup);
		},
		reset() {
			this.showCreate = false;
			this.showEdit = false;
			this.editedTagGroup = false;
		},
		selectDefaultIfNone() {
			if (!this.selectedTagGroup) {
				this.setSelected(this.tagGroups.find(tg => tg.isDefault));
			}
		},
		closeEdit() {
			this.showEdit = false;
			this.editedTagGroup = null;
		},
		closeSettings() {
			this.reset();
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@videotools/sass/settings";
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts.scss';

.settings {
	@include z-index('asport-one-settings', 'global');
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	overflow-x: hidden;
	display: flex;
	flex-direction: column;
	background: var(--color-black);
	color: var(--color-soft-white);

	> div {
		flex: 1;
	}

	&-content {
		display: flex;
		min-height: 0;
	}
}

</style>
